/**
 * OrbPostMachinesWithTraitsPart1VisionARPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbPostMachinesWithTraitsPart1VisionARPostPage
 */

import { useOrbPostMachinesWithTraitsPart1VisionARPostPageLogic } from '@/hooks/traits/useOrbPostMachinesWithTraitsPart1VisionARPostPageLogic';
import type { OrbPostMachinesWithTraitsPart1VisionARPostPageConfig } from '@/hooks/traits/useOrbPostMachinesWithTraitsPart1VisionARPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbPostMachinesWithTraitsPart1VisionARPostView as OrbPostMachinesWithTraitsPart1VisionARPostViewEntity } from '@app/shared';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { OrbPostMachinesWithTraitsPart1VisionARPostFooterView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionARPostFooterView';
import { OrbPostMachinesWithTraitsPart1VisionARPostHeaderView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionARPostHeaderView';
import { OrbPostMachinesWithTraitsPart1VisionARPostView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionARPostView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbPostMachinesWithTraitsPart1VisionARPostPageViewProps {
  config?: Partial<OrbPostMachinesWithTraitsPart1VisionARPostPageConfig>;
}

export function OrbPostMachinesWithTraitsPart1VisionARPostPageView({ config: propsConfig }: OrbPostMachinesWithTraitsPart1VisionARPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbPostMachinesWithTraitsPart1VisionARPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbPostMachinesWithTraitsPart1VisionARPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbPostMachinesWithTraitsPart1VisionAR" trait="OrbPostMachinesWithTraitsPart1VisionARPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbPostMachinesWithTraitsPart1VisionARPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbPostMachinesWithTraitsPart1VisionARPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" fullWidth={true} paddingY="xl"><Container maxWidth="xl" padding="lg" size="xl"><OrbPostMachinesWithTraitsPart1VisionARPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><OrbPostMachinesWithTraitsPart1VisionARPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbPostMachinesWithTraitsPart1VisionARPostPageView;
